<div class="overview-wrapper">
  <div class="right-panel">

    <!-- About Company -->
    <div class="about">
      <h2>{{ 'companyOverview.aboutCompany' | translate }}</h2>
      <div *ngIf="companyProfile?.aboutCompany; else noAbout" [innerHTML]="companyProfile!.aboutCompany"></div>
      <ng-template #noAbout>
        <p>-</p>
      </ng-template>
    </div>

    <!-- Company Benefits -->
    <div class="benefits">
      <h2>{{ 'companyOverview.companyBenefits' | translate }}</h2>
      <ng-container *ngIf="companyProfile?.benefits; else noBenefits">
        <div *ngFor="let b of transformedBenefits" [innerHTML]="b"></div>
      </ng-container>
      <ng-template #noBenefits>
        <p>-</p>
      </ng-template>
    </div>

    <!-- Company Vision -->
    <div class="vision">
      <h2>{{ 'companyOverview.companyVision' | translate }}</h2>
      <ng-container *ngIf="companyProfile?.vision; else noVision">
        <div *ngFor="let b of transformedVision" [innerHTML]="b"></div>
      </ng-container>
      <ng-template #noVision>
        <p>-</p>
      </ng-template>

    </div>

    <!-- Company Rating -->
    <div class="rating-section mt-4">
      <div class="rating-header">
        <h2>{{ 'companyOverview.companyRating' | translate }}</h2>
        <div class="rating-summary">
          <span class="rating-number">{{ companyProfile?.rate ?? '-' }}</span>
          <div class="rating-stars-wrap">
            <div class="stars">
              <i *ngFor="let star of starsArray" class="bi" [ngClass]="star"></i>
            </div>
            <span class="rating-count">{{ 'companyOverview.basedOn' | translate }} {{ companyProfile?.rateCount ?? 0 }}
              {{ 'companyOverview.reviews' | translate }}</span>
          </div>
        </div>
      </div>

      <!-- Loading -->
      <div *ngIf="isLoadingComments" class="reviews-loading">
        <span>{{ 'companyOverview.loadingReviews' | translate }}</span>
      </div>

      <!-- Reviews List -->
      <div class="reviews-list" *ngIf="!isLoadingComments">
        <p class="no-reviews" *ngIf="comments.length === 0">{{ 'companyOverview.noReviewsYet' | translate }}</p>

        <!-- Review Item -->
        <div class="review-item" *ngFor="let comment of comments">

          <!-- Top Row: avatar + info | stars -->
          <div class="review-top">
            <div class="review-left">
              <div class="reviewer-avatar">
                <img *ngIf="comment.userPicture; else initials" [src]="getuserimage(comment)" [alt]="comment.userName"
                  class="avatar-img" />
                <ng-template #initials>
                  <div class="avatar-initials">{{ getUserInitials(comment.userName) }}</div>
                </ng-template>
              </div>
              <div class="reviewer-info">
                <p class="reviewer-role">{{ comment.userName }}</p>
                <p class="reviewer-text">"{{ comment.content }}"</p>
              </div>
            </div>
            <div class="review-stars">
              <i *ngFor="let star of getCommentStars(comment.rate)" class="bi" [ngClass]="star"></i>
            </div>
          </div>

          <!-- Replies -->
          <div class="replies-section" *ngIf="comment.replies && comment.replies.length > 0">
            <div class="reply-item" *ngFor="let reply of comment.replies">
              <div class="reply-avatar-wrap">
                <img *ngIf="reply.authorPicture; else replyInitials" [src]="getReplyAuthorImage(reply)"
                  [alt]="reply.authorName" class="avatar-img reply-avatar-sm-img" />
                <ng-template #replyInitials>
                  <div class="avatar-initials reply-avatar-sm">
                    {{ getUserInitials(reply.authorName) }}
                  </div>
                </ng-template>
              </div>
              <div class="reply-body">
                <div class="reply-header">
                  <span class="reply-name">{{ reply.authorName }}</span>
                  <span class="reply-date">{{ reply.createdAt | date: 'MMM d, yyyy' }}</span>
                </div>
                <span class="reply-text-inline">"{{ reply.content }}"</span>
              </div>
            </div>
          </div>

        </div>
      </div>

      <button class="add-review-btn" (click)="openReviewModal()">
        <i class="bi bi-plus"></i> {{ 'companyOverview.addReview' | translate }}
      </button>
    </div>

  </div>

  <div class="left-panel">

    <!-- Company Info -->
    <div class="info">
      <div class="info-card">
        <div class="icon"><i class="bi bi-calendar4"></i></div>
        <p class="title">{{ 'companyOverview.foundedIn' | translate }}:</p>
        <p class="subtitle">{{ companyProfile?.foundedIn ?? '-' }}</p>
      </div>
      <div class="info-card">
        <div class="icon"><i class="bi bi-clock"></i></div>
        <p class="title">{{ 'companyOverview.organizationType' | translate }}</p>
        <p class="subtitle">{{ companyProfile?.orgType || '-' }}</p>
      </div>
      <div class="info-card">
        <div class="icon"><i class="bi bi-calendar2-event"></i></div>
        <p class="title">{{ 'companyOverview.teamSize' | translate }}</p>
        <p class="subtitle">
          <ng-container *ngIf="companyProfile?.companySizeFrom && companyProfile?.companySizeTo; else noSize">
            {{ companyProfile!.companySizeFrom }} - {{ companyProfile!.companySizeTo }} {{ 'companyOverview.employees' |
            translate }}
          </ng-container>
          <ng-template #noSize>-</ng-template>
        </p>
      </div>
      <div class="info-card">
        <div class="icon"><i class="bi bi-briefcase"></i></div>
        <p class="title">{{ 'companyOverview.industryTypes' | translate }}</p>
        <p class="subtitle">{{ companyProfile?.industryType || '-' }}</p>
      </div>
    </div>

    <!-- Contact Info -->
    <div class="contact-info">
      <h3>{{ 'companyOverview.contactInformation' | translate }}</h3>
      <div class="contact-card">
        <div class="icon"><i class="bi bi-globe"></i></div>
        <div>
          <p class="title">{{ 'companyOverview.website' | translate }}</p>
          <p class="subtitle">
            <span *ngIf="companyProfile?.website; else noWebsite" class="link-text"
              (click)="openLink(companyProfile?.website)">
              {{ companyProfile?.website }}
            </span>
            <ng-template #noWebsite>-</ng-template>
          </p>
        </div>
      </div>
      <div class="contact-card">
        <div class="icon"><i class="bi bi-telephone-inbound"></i></div>
        <div>
          <p class="title">{{ 'companyOverview.recruitmentContact' | translate }}</p>
          <p class="subtitle">{{ companyProfile?.phoneNumber || '-' }}</p>
        </div>
      </div>
      <div class="contact-card">
        <div class="icon"><i class="bi bi-envelope"></i></div>
        <div>
          <p class="title">{{ 'companyOverview.emailAddress' | translate }}</p>
          <p class="subtitle">{{ companyProfile?.email || '-' }}</p>
        </div>
      </div>
    </div>

    <!-- Social Links -->
    <div class="social-links">
      <h3>{{ 'companyOverview.followUsOn' | translate }}:</h3>
      <div class="icons">
        <div class="icon" [class.disabled-link]="!companyProfile?.facebookLink"
          (click)="openLink(companyProfile?.facebookLink)">
          <i class="bi bi-facebook"></i>
        </div>
        <div class="icon" [class.disabled-link]="!companyProfile?.twitterLink"
          (click)="openLink(companyProfile?.twitterLink)">
          <i class="bi bi-twitter-x"></i>
        </div>
        <div class="icon" [class.disabled-link]="!companyProfile?.instagramLink"
          (click)="openLink(companyProfile?.instagramLink)">
          <i class="bi bi-instagram"></i>
        </div>
        <div class="icon" [class.disabled-link]="!companyProfile?.youtubeLink"
          (click)="openLink(companyProfile?.youtubeLink)">
          <i class="bi bi-youtube"></i>
        </div>
        <div class="icon" [class.disabled-link]="!companyProfile?.linkedinLink"
          (click)="openLink(companyProfile?.linkedinLink)">
          <i class="bi bi-linkedin"></i>
        </div>
        <div class="icon" [class.disabled-link]="!companyProfile?.snapchatLink"
          (click)="openLink(companyProfile?.snapchatLink)">
          <i class="bi bi-snapchat"></i>
        </div>
      </div>
    </div>

  </div>

  <!-- Review Modal -->
  <div class="modal-overlay" *ngIf="showReviewModal" (click)="closeReviewModal()">
    <div class="modal-box" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ 'companyOverview.addYourReview' | translate }}</h3>
        <button class="modal-close" (click)="closeReviewModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-success" *ngIf="submitSuccess">
        <i class="bi bi-check-circle-fill"></i>
        <p>{{ 'companyOverview.reviewSubmittedSuccessfully' | translate }}</p>
      </div>
      <div *ngIf="!submitSuccess">
        <div class="modal-stars-label">{{ 'companyOverview.yourRating' | translate }}</div>
        <div class="modal-stars" (mouseleave)="clearHovered()">
          <i *ngFor="let star of [1,2,3,4,5]" class="bi" [ngClass]="getStarClass(star)" (click)="setRate(star)"
            (mouseenter)="setHovered(star)"></i>
        </div>
        <div class="modal-field">
          <label>{{ 'companyOverview.yourReview' | translate }}</label>
          <textarea [(ngModel)]="reviewContent" [placeholder]="'companyOverview.writeExperiencePlaceholder' | translate"
            rows="4"></textarea>
        </div>
        <p class="modal-error" *ngIf="submitError">{{ submitError }}</p>
        <div class="modal-actions">
          <button class="btn-cancel" (click)="closeReviewModal()">{{ 'companyOverview.cancel' | translate }}</button>
          <button class="btn-submit" (click)="submitReview()" [disabled]="isSubmitting">
            <span *ngIf="!isSubmitting">{{ 'companyOverview.submitReview' | translate }}</span>
            <span *ngIf="isSubmitting">{{ 'companyOverview.submitting' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

</div>